var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningShadowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "#FCF5F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 18.25C24.4142 18.25 24.75 18.5858 24.75 19V25C24.75 25.4142 24.4142 25.75 24 25.75C23.5858 25.75 23.25 25.4142 23.25 25V19C23.25 18.5858 23.5858 18.25 24 18.25Z",
    fill: "#FF4336"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5117 28.4414C24.8196 28.7185 24.8446 29.1927 24.5675 29.5006L24.5575 29.5117C24.2804 29.8196 23.8062 29.8446 23.4983 29.5675C23.1904 29.2904 23.1654 28.8162 23.4425 28.5083L23.4525 28.4972C23.7296 28.1893 24.2038 28.1643 24.5117 28.4414Z",
    fill: "#FF4336"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 14.75C18.8914 14.75 14.75 18.8914 14.75 24C14.75 29.1086 18.8914 33.25 24 33.25C29.1086 33.25 33.25 29.1086 33.25 24C33.25 18.8914 29.1086 14.75 24 14.75ZM13.25 24C13.25 18.0629 18.0629 13.25 24 13.25C29.9371 13.25 34.75 18.0629 34.75 24C34.75 29.9371 29.9371 34.75 24 34.75C18.0629 34.75 13.25 29.9371 13.25 24Z",
    fill: "#FF4336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningShadowIcon);
export default __webpack_public_path__ + "static/media/Warning-Shadow-icon.d26bfeaef8d7860331e2416d7c7ba891.svg";
export { ForwardRef as ReactComponent };